import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import { Row } from '../Row';
import type { StyledListRootProps } from './List.types';

export const StyledListWrapper = styled(Row)<StyledListRootProps>(({ size, theme }) => {
  return {
    height: size === 'XL' ? 56 : 48,
    padding: '12px 16px',
    backgroundColor: theme.palette.bg.primaryInverse,
    ...theme.typography.body2.regular,
  };
}, getAllStyledProps);
